import Animation from "./animation";

class Animator {
  constructor(config = {}) {
    this.animations = config.animations
      .filter((animationConfig) => animationConfig.element)
      .map((animationConfig) => new Animation(animationConfig));
  }

  // TODO: JUST USE FUNCTIONS FOR EACH ANIMATION THING LOL DUH. MAKE THOSE
  // FUNCTIONS RETURN A HASH OF RESULTS SO THEY CAN BE NAMED ARGS FOR THE STYLE
  // FUNCTION. THIS WILL ALLOW FOR CLAMPING AND LIMITS ON SCROLL RANGE TO BE
  // OPTIONAL. THE FUNCTION WILL TAKE THE SCROLL Y AND X AS ARGUMENTS.

  // MAYBE THAT'S NOT THE BEST IDEA. THE LAST BITS ON SCROLL RANGE. FORGOT WHY.
  // OOPS. OH WAIT. IT MIGHT BE BAD BECAUSE THEN WE'RE SETTING THE STLYE ON THE
  // ELEMENT EVERY SCROLL EVENT. WHICH SEEMS WASTEFUL. WHAT IF INSTEAD THERE WAS
  // A FUNCTION FOR EACH ANIMATION WHICH RETURNED TRUE/FALSE TO DETERMINE IF IT
  // SHOULD UPDATE? IT CAN GRAB THE SCROLL X AND Y OR WHATEVER IT NEEDS. IF IT
  // RETURNS TRUE WE UPDATE GIVEN THE AFORMENTIONED UPDATE FUNCTION. OTHERWISE
  // JUST DO NOTHING WITH THIS ANIMATION.

  // SKIP IT. WALK AWAY. HIT DA BRICKS. LEAVE.

  // GLAD I WROTE ALL THAT DOWN.
  animate(scrollEvent) {
    this.animations.forEach((animation) => {
      animation.render();
    });
  }
}

export default Animator;
